module.exports = __webpack_public_path__ + "static/tooltip-close.94f6d0df.svg";